"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureVisitorID = void 0;
const crypto_1 = require("crypto");
/**
 * Gets the visitor ID from our cookie, if uninitialized, create one and update
 * the cookie. This keeps visitor IDs in sync with frontend logic.
 *
 * @param websiteData manages persistence
 * @param idGenerator used to generate a new ID if needed (in a uniformly random distribution)
 * @returns null if no visitor ID could be assigned, otherwise the assigned visitor ID
 */
function ensureVisitorID(websiteData, idGenerator = crypto_1.randomUUID) {
    let vid = websiteData.getVisitorID();
    if (!vid) {
        vid = idGenerator();
        websiteData.setVisitorID(vid);
    }
    return vid;
}
exports.ensureVisitorID = ensureVisitorID;
//# sourceMappingURL=visitor.js.map